import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Props from './components/props.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "props"
    }}>{`Props`}</h1>
    <Props mdxType="Props" />
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <h3 {...{
      "id": "example-1"
    }}>{`Example-1`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`This is the example for the props - options , placeholder and defaultIndex`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`options is the required prop to be passed to the combo-box.`}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'

const App = () => {
  const options = [
    'America',
    'India',
    'Australia',
    'Argentina',
    'Ireland',
    'Indonesia',
    'Iceland',
    'Japan'
  ]

  return (
    <div>
      <ComboBox
        options={options}
        placeholder='Enter your country'
        defaultIndex={1}
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-2"
    }}>{`Example-2`}</h3>
    <ul>
      <li parentName="ul">{`This is the example for props - wrapperClassName, listClassname, popoverClassName, inputClassName, className, style, highlightColor and selectedOptionColor.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.Combo-box {
  width:'300px'
  height:'80px'
}

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'

import './index.css'

const App = () => {
  const options = [
    'America',
    'India',
    'Australia',
    'Argentina',
    'Ireland',
    'Indonesia',
    'Iceland',
    'Japan'
  ]

  return (
    <div>
      <ComboBox
        options={options}
        className='combo-box-option'
        wrapperClassName='combo-box-wrapper'
        inputClassName='combo-box-input'
        popoverClassName='combo-box-popover'
        listClassName='combo-box-list'
        style={{ margin: '10px' }}
        hightlighColor='#C6F6D5'
        selectedOptionColor='#68D391'
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-3"
    }}>{`Example-3`}</h3>
    <ul>
      <li parentName="ul">{`This is example for the props - onChange, onSelect and onOptionsChange`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'

const App = () => {
  const [selectedOption, setSelectedOption] = useState('')
  const options = [
    'America',
    'India',
    'Australia',
    'Argentina',
    'Ireland',
    'Indonesia',
    'Iceland',
    'Japan'
  ]

  return (
    <div>
      <ComboBox
        options={options}
        onChange={(event) => console.log(event.target.value)}
        onSelect={(option) => setSelectedOption(option)}
        onOptionsChange={(option) => console.log(option)}
      />
      <p>The selected option is {selectedOption}</p>
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-4"
    }}>{`Example-4`}</h3>
    <ul>
      <li parentName="ul">{`This is example for the props - optionsListMaxHeight, renderOptions and enableAutocomplete`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'

const App = () => {
  const options = [
    'America',
    'India',
    'Australia',
    'Argentina',
    'Ireland',
    'Indonesia',
    'Iceland',
    'Japan'
  ]

  return (
    <div>
      <ComboBox
        options={options}
        optionsMaxHeight={500}
        renderOptions={(option) => (
          <div style={{ padding: '10px' }}>This is {option}</div>
        )}
        enableAutocomplete
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-5"
    }}>{`Example-5`}</h3>
    <ul>
      <li parentName="ul">{`This is example for the props - style and inputStyles`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'

const App = () => {
  const options = [
    'America',
    'India',
    'Australia',
    'Argentina',
    'Ireland',
    'Indonesia',
    'Iceland',
    'Japan'
  ]

  return (
    <div>
      <ComboBox
        options={options}
        style={{ width: '500px', margin: '30px' }}
        inputStyles={{ border: '1px solid #333' }}
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-6"
    }}>{`Example-6`}</h3>
    <ul>
      <li parentName="ul">{`This is example for the props - onBlur and editable`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'

const App = () => {
  const options = [
    'America',
    'India',
    'Australia',
    'Argentina',
    'Ireland',
    'Indonesia',
    'Iceland',
    'Japan'
  ]

  return (
    <div>
      <ComboBox
        options={options}
        editable={false}
        onBlur={() => console.log('The component is blurred')}
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-7"
    }}>{`Example-7`}</h3>
    <ul>
      <li parentName="ul">{`This is example for the props - renderLeftElement and renderRightElement`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'
import { AiFillCaretDown, AiFillFilter } from 'react-icons/ai'

const App = () => {
  const options = [
    'America',
    'India',
    'Australia',
    'Argentina',
    'Ireland',
    'Indonesia',
    'Iceland',
    'Japan'
  ]

  return (
    <div>
      <ComboBox
        options={options}
        renderRightElement={()=> <AiFillCaretDown /> }
        renderLeftElement={()=> <AiFillFilter /> }

      />
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      